import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { RichText } from '../rich-text/rich-text.esm.js';

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use standard HTML div element with Bootstrap classes instead.
 * See the type documentation above for migration examples.
 */ const Body = ({ children, className, left = false, right = false, center = false, ...rest })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        const alignmentClass = left ? ' text-start' : right ? ' text-end' : center ? ' text-center' : '';
        console.warn('⚠️  Body component is deprecated and will be removed in a future version.\n' + 'Please migrate to using standard HTML div element with Bootstrap classes:\n' + `• Replace <Body${left ? ' left' : ''}${right ? ' right' : ''}${center ? ' center' : ''}> with:\n` + `• <div className="p${alignmentClass}${className ? ` ${className}` : ''}"> \n` + '• For string children, add dangerouslySetInnerHTML={{__html: stringContent}} and remove children prop');
    }
    const classes = classNames(className, 'p', {
        'text-end': right,
        'text-center': center,
        'text-start': left
    });
    return jsx(RichText, {
        as: "div",
        renderChildrenAsHTML: true,
        className: classes,
        ...rest,
        children: children
    });
};

export { Body };
